<script>
import firebase from '@firebase/app'
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  data(){
    return{
      testData: [],
      chartdata: {
        labels: [],
        datasets: [
            {
                type: 'line',
                label: '感情スコア',
                backgroundColor: '#FB9A98',
                data: []
            }
        ]
      },
      options:{
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              stepSize: 10,
            }
          }]
        },
        layout: { //レイアウトの設定
          padding: {
            left: 2,
            right: 2,
            top: 0,
            bottom: 0
          }
        }
      },
    }
  },
  computed:{
    user(){
      return this.$store.getters.user;
    },
    today(){
      return this.$store.getters.today_info;
    },
  },
  created(){
    //今月の日数取得
    var [ , , year_path, month_path] = location.pathname.split('/')
    this.year_path = year_path
    this.month_path = month_path
    
    const getLastDay = (year, month) => {
    return new Date(year, month, 0).getDate();
    };
    const lastDay = getLastDay(year_path, month_path);

    //ループで日数を配列をセット
    for(var i = 1; i <= lastDay; i++){
      this.chartdata.labels.push(i);
    }
    //ループで文字数の配列をセット
    for(var a = 1; a <= lastDay; a++){
      this.chartdata.datasets[0].data.push(0)
    }


    firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).get().then(snapshot => {
      snapshot.forEach(doc => {
      var data = doc.data()
      var index =  data.day - 1
      var score = data.score * 100
      this.chartdata.datasets[0].data.splice(index, 1, score)
      })
    }).then(()=>{
      this.renderChart(this.chartdata, this.options)
    })
  }
}

</script>